import { enableAllPlugins } from 'immer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import DashboardContainer from './apps/kogan/features/dashboard/components/DashboardContainer';
import DefaultErrorPage from './common/errors/DefaultErrorPage';
import { fetchProducts } from './apps/kogan/features/productmanagement/slices/productsSlice';
import store from './common/store/store';
import ProductsContainer from './apps/kogan/features/productmanagement/components/ProductsContainer';
import './index.css';
import OrdersContainer from './apps/kogan/features/ordermanagement/components/OrdersContainer';
import reportWebVitals from './reportWebVitals';
import ImagesContainer from './apps/s3images/features/imagemanagement/components/ImagesContainer';
import SettingsContainer from './apps/kogan/features/settings/components/SettingsContainer';
import { Amplify } from 'aws-amplify';
import ENV from './common/config/env';
import LoginComponent from './common/components/auth/LoginComponent';
import LandingPage from './common/components/LandingPage';
const config = ENV.amplifyConfig;
Amplify.configure({
  ...config
});
enableAllPlugins();
const root = ReactDOM.createRoot(document.getElementById('root'));
const router = createBrowserRouter([
  {
    path: '/',
    element: <App style={{ height: '100%' }} />,
    errorElement: <DefaultErrorPage />,
    children: [
      {
        index: true,
        element: <DashboardContainer />,
      },
      {
        errorElement: <DefaultErrorPage />,
        children: [
          {
            path: '/products',
            element: <ProductsContainer />,
          },
          {
            path: '/orders',
            element: <OrdersContainer />,
          },
          {
            path: '/images',
            element: <ImagesContainer />,
          },
          {
            path: '/settings',
            element: <SettingsContainer />,
          },
        ],
      },
    ],
  },
  // {
  //   path:'/login',
  //   element:<LandingPage/>
  // }
]);
store.dispatch(fetchProducts());
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
